import { useTranslations } from 'next-intl';
import type { SearchResult, SearchType } from '../../types';
import { AllProductsResults } from './AllProductsResults';

type SearchResultsProps = {
  searchType: SearchType;
  results: SearchResult[];
  searchTerm: string;
  onResultClick: (result: SearchResult) => void;
  className?: string;
};

/**
 * SearchResults component that displays the search results for the given search type. It will display the appropriate results for the given search type.
 *
 * @param searchType - The type of search to perform (games, lotteries, syndicates, scratchcards, all)
 * @param results - The results to display
 * @param searchTerm - The search term to display in the results
 * @param onResultClick - The function to call when a result is clicked
 * @param className - The className to apply to the component
 * @returns A div with the search results for the given search type
 */
function SearchResults({ searchType, results, searchTerm, onResultClick, className }: SearchResultsProps) {
  const t = useTranslations('general.search');

  const handleResultClick = (result: SearchResult) => {
    onResultClick(result);
  };

  return (
    <div className={className} data-track-container="Results">
      <p>{t(`${searchType}_found`, { count: results.length })}</p>
      <AllProductsResults results={results} searchTerm={searchTerm} searchType={searchType} onResultClick={handleResultClick} data-track-container="Navigation List" />
    </div>
  );
}

export { SearchResults };
